import { Grid } from "@material-ui/core";
import React from "react";
import BoxAllesKönner from "./alleskönner";
import BoxModel from "./model";
import BoxModelDINH from "./model_DINH";
import BoxVideo from "./video";

const ModelBox = (props) => {
  let { ModelID, Soort } = props.data;
  const { history } = props;

  return (
    <Grid key={Soort + ModelID} item xs={12} md={6}>
      {
        {
          model: <BoxModel history={history} data={props.data} />,
          modellen_DINH: <BoxModelDINH history={history} data={props.data} />,
          AllesKönner: <BoxAllesKönner history={history} data={props.data} />,
          pin: <div>pin {ModelID}</div>,
          video: <BoxVideo history={history} data={props.data} />,
        }[Soort]
      }
    </Grid>
  );
};

export default ModelBox;
